// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Epa8","content":"styles_content__1JsM9","checkbox":"styles_checkbox__1drkP","checkboxLabel":"styles_checkboxLabel__1AWBH"};